/******************/
/* FORM VALIDATOR */
/******************/

class FormValidator {
    _validators = {}

    constructor(validators = {}) {
        Object.keys(validators).forEach((field) => {
            if('valid' in validators[field]) {
                this._validators[field] = validators[field]
            } else {
                this.addRules(field, validators[field].rules, validators[field].state)
            }
        });

        // console.log("constructor", this._validators)
    }

    addRules(fieldName, rules, state) {
        if(rules !== undefined && rules !== null && Array.isArray(rules)) {
            rules.forEach(rule => {
                if(typeof rule.test !== "function" && !rule.test instanceof RegExp) {
                    throw Error('Invalid rule on '+fieldName)
                }
            });
        }

        this._validators[fieldName] = {
            errors: [],
            valid: true,
            rules: rules,
            state: state
        }
    }

    validateField(name, value) {
        let isValid = true;

        if(this._validators[name] !== undefined && this._validators[name] !== null ) 
        {
            this._validators[name].state = value;
            this._validators[name].errors = [];

            this._validators[name].rules.forEach((rule) => {
                if (rule.test instanceof RegExp) {
                    if (!rule.test.test(value)) {
                        this._validators[name].errors.push(rule.message);
                        isValid = false;
                    }
                    // console.log("regExp", isValid, this._validators[name]);
                } else if (typeof rule.test === "function") {
                    if (!rule.test(value)) {
                        this._validators[name].errors.push(rule.message);
                        isValid = false;
                    }
                    // console.log("func", isValid, this._validators[name]);
                }
            });
            
            this._validators[name].valid = isValid;
            // console.log("validate", isValid, this._validators)
        }

        return isValid;
    }

    isValid() {
        let isValidForm = true;
        // console.log(this._validators);
        Object.keys(this._validators).forEach((fieldName) => {
            isValidForm = isValidForm && this._validators[fieldName].valid;
        });
        return isValidForm;
    }

    getFieldErrors(name) {
        let errors = [];
        if(this._validators[name] && !this._validators[name].valid) {
            errors = this._validators[name].errors;
        }
        // console.log("getFieldErrors", errors, this._validators)
        return errors;
    }

    getValidators() {
        return this._validators
    }
}

export { FormValidator }